export const Prefixes = [
  'Dr.',
  'Dr. Ing.',
  'Drs.',
  'Drs. Ing.',
  'Hog.',
  'Ing.',
  'Ir.',
  'Ir. Drs.',
  'Mr.',
  'Mrs.',
  'Ms.',
  'Prof.',
  'Prof. Dr.',
  'Rev.',
  'Sir.'
];

export const Suffixes = [
  'CFA',
  'CP',
  'MA',
  'MA MRE',
  'MBA',
  'MBE',
  'MFE',
  'MMRE',
  'MRE',
  'MSRE',
  'OBE',
  'PE MFE',
  'PhD',
  'PMFE',
  'RA',
  'RBA'
];
